import { useAuthUserMembership } from "../../memberships/hooks/use-auth-user-membership"

export const useCanViewReportedHoursTab = () => {
  const {
    canViewAnyHourReport,
    canReportOwnHoursAsMember,
    canReportOwnHoursAnywhere,
    canReportOthersHoursAsMember,
    canReportOthersHoursAnywhere,
  } = useAuthUserMembership()

  return Boolean(
    canViewAnyHourReport ||
      canReportOwnHoursAsMember ||
      canReportOwnHoursAnywhere ||
      canReportOthersHoursAsMember ||
      canReportOthersHoursAnywhere
  )
}
